module.exports = {
	"id": "TC",
	"name": "Turks and Caicos Islands",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.010858,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.005429,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": 0.016287,
			"36": 0.021716,
			"37": null,
			"38": null,
			"39": null,
			"40": 0.027145,
			"41": null,
			"42": 0.005429,
			"43": 0.010858,
			"44": 0.032574,
			"45": 0.021716,
			"46": 0.048861,
			"47": 0.027145,
			"48": 0.032574,
			"49": 1.069513,
			"50": 0.065148,
			"51": 0.173728,
			"52": 0.255163,
			"53": 19.446678,
			"54": 5.667876,
			"55": 0.043432,
			"56": 0.027145,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": 0.070577,
			"16": null,
			"17": null,
			"18": 0.021716,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.016287,
			"32": 0.065148,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.021716,
			"39": null,
			"40": 0.027145,
			"41": null,
			"42": 0.05429,
			"43": 0.065148,
			"44": null,
			"45": 0.032574,
			"46": 0.005429,
			"47": 0.070577,
			"48": 1.080371,
			"49": 4.516928,
			"50": 0.249734,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.016287,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.010858,
			"34": null,
			"35": null,
			"36": 0.005429,
			"37": 0.05429,
			"38": null,
			"39": null,
			"40": 0.065148,
			"41": null,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.05429,
			"6": 0.032574,
			"7": 0.021716,
			"8": 0.135725,
			"9": 0.287737,
			"10": 1.525549,
			"3.1": null,
			"3.2": null,
			"5.1": 0.152012,
			"6.1": 0.016287,
			"7.1": null,
			"9.1": 1.84586
		},
		"ios_saf": {
			"8": 0,
			"10": 13.9612574421,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.376239733139,
			"8.1-8.4": 0.695086964613,
			"9.0-9.2": 0.331601120733,
			"9.3": 5.05904273938
		},
		"android": {
			"3": 0,
			"4": 0.0492770335917,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00615962919897,
			"4.1": 0.177749299742,
			"4.2-4.3": 0.444373249354,
			"4.4": 1.01897865891,
			"4.4.3-4.4.4": 1.0277781292
		},
		"ie": {
			"6": null,
			"7": 0.0163149845361,
			"8": 0.108766563574,
			"9": 0.114204891753,
			"10": 0.190341486254,
			"11": 5.90058607388,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0119786735518,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000332740931995
		},
		"edge": {
			"12": 0.515755,
			"13": 0.950075,
			"14": 3.235684
		},
		"ie_mob": {
			"10": 0.0477701690141,
			"11": 0.194492830986
		},
		"bb": {
			"7": 0.10627575,
			"10": null
		},
		"samsung": {
			"0": 3.999625
		},
		"and_uc": {
			"0": 0.351967
		},
		"op_mini": {
			"0": 0.161386585516
		},
		"and_chr": {
			"0": 21.02155
		},
		"and_ff": {
			"0": 0.082278
		}
	},
	"total": 97.68760575
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/TC.json
 ** module id = 655
 ** module chunks = 0
 **/